import { type DynamicClient, getNetworksData } from '@dynamic-labs-sdk/client';

/**
 * Returns the numeric IDs of the EVM networks configured on the Dynamic
 * client. Generic helper available to any EVM extension that needs to
 * advertise the configured chain set to a third-party SDK (e.g. Base
 * Account, WalletConnect).
 *
 * @param client - The Dynamic client whose project settings drive the result.
 * @not-instrumented
 */
export const getEvmNetworkIds = (client: DynamicClient): number[] =>
  getNetworksData(client).reduce<number[]>((networkIds, network) => {
    if (network.chain !== 'EVM') return networkIds;
    const networkId = Number.parseInt(network.networkId, 10);
    if (!Number.isFinite(networkId)) return networkIds;
    networkIds.push(networkId);
    return networkIds;
  }, []);
